module.exports = __webpack_public_path__ + "img/my-contracts.b893dd48.svg";